<div class="booking-error" role="alert" aria-live="assertive">
  <div class="booking-error__icon-wrapper">
    <mat-icon class="booking-error__icon">{{ icon() }}</mat-icon>
  </div>
  <div class="booking-error__text">
    <h2 class="booking-error__title">{{ title() }}</h2>
    <p class="booking-error__message">{{ message() }}</p>
  </div>
  @if (buttonLabel()) {
    <button
      mat-flat-button
      color="primary"
      class="booking-error__button"
      (click)="onButtonClick()"
    >
      {{ buttonLabel() }}
    </button>
  }
</div>
